import { Text } from 'Shared/forms/Inputs';
import { LabelOnRightWrap } from 'Shared/forms/Wrap';


/* The corner radius on its own, for a caller that names the location itself - see ruleProperties().
   A css length ('0.4em', '6px'); empty contributes nothing. There is no Selector variant because
   only the Style Builder offers this one. */
export function CornerRadiusFields()
{
	return (
		<LabelOnRightWrap label='' narrow={true}>
			<Text field='radius' placeholder='e.g. 0.4em' />
		</LabelOnRightWrap>
	);
}
